import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Typography, Space, Button, Card } from 'antd';
import { CheckCircleOutlined, ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

function ResetPasswordSentScreen() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = t('resetPasswordSent.pageTitle');
    }, [t]);

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <Card style={{ borderRadius: 16 }} bodyStyle={{ padding: 32 }}>
                    <Title level={2} style={{ textAlign: 'center', marginBottom: 24 }}>
                        {t('resetPasswordSent.title')}
                    </Title>
                    <div style={{ textAlign: 'center' }}>
                        <CheckCircleOutlined style={{ fontSize: 50, color: '#52c41a' }} />
                    </div>
                    <Title level={4} style={{ textAlign: 'center' }}>
                        {t('resetPasswordSent.linkSentSuccessfully')}
                    </Title>
                    <Paragraph>
                        {t('resetPasswordSent.accountExistsMessage')}
                    </Paragraph>
                    <Paragraph>
                        {t('resetPasswordSent.linkExpiryMessage')}
                    </Paragraph>
                    <Button 
                        icon={<ArrowLeftOutlined />} 
                        onClick={() => navigate(-1)()}
                        style={{ marginTop: 16 }}
                        size="large"
                    >
                        {t('resetPasswordSent.goBack')}
                    </Button>
                </Card>
            </Space>
    );
}

export default ResetPasswordSentScreen;